// extracted by mini-css-extract-plugin
export default {"post-container":"style_post-container__2k2Ob","post-card":"style_post-card__kpcEb"};